import React, { useEffect, useMemo, useState } from 'react';
import styles from './ConfirmDialog.module.less';
import TextureNoise from '@/assets/logo.png';
import closeIcon from '@/assets/project/closewhite.png';
import { infoController } from '@/api';
import { Modal, Spin } from 'antd';
import { useSelector } from 'react-redux';

const ConfirmDialog = (props) => {
  const [show, setShow] = useState(true);
  return (
    <Modal
      open={show}
      closeIcon={<img className={'modal-close-icon'} src={closeIcon}></img>}
      wrapClassName="custom-modal"
      onCancel={() => {
        props?.onCancel();
        setShow(false);
      }}
      footer={<></>}>
      <div className={styles.popContent}>
        <div className={styles.icon}></div>
        <div className={styles.content}>{props.content}</div>
        <div className={styles.buttons}>
          <div
            className={styles.cancelButton}
            onClick={() => {
              props?.onCancel();
              setShow(false);
            }}>
            {props.cancelTitle || 'Cancel'}
          </div>
          <div
            className={styles.confirmButton}
            onClick={() => {
              props?.onConfirm();
              setShow(false);
            }}>
            {props.confirmTitle || 'Confirm'}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDialog;
